import {
  groupSelectWithRegionsTranslation,
  GroupSelectWithRegionsTranslation,
} from '@/assets/locales/form/GroupSelectWithRegions/GroupSelectWithRegions.translation.en';

export type FormTranslation = {
  dateFormField: {
    chooseDate: string;
  };
  groupSelectWithRegions: GroupSelectWithRegionsTranslation;
  selectAll: string;
};

export const formTranslation: FormTranslation = {
  dateFormField: {
    chooseDate: 'Choose Date',
  },
  groupSelectWithRegions: groupSelectWithRegionsTranslation,
  selectAll: 'Select All',
};
